import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="bg-[#0369A1] py-20 px-4 relative overflow-hidden" data-id="element-260">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-261">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border-[20px] border-[#F97316]" data-id="element-262"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full border-[20px] border-[#F97316]" data-id="element-263"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-265">
          <span className="inline-block text-[#F97316] text-xl mb-4 font-bold tracking-widest uppercase" data-id="element-266">
            🏆 El Sistema N°1 para Entrenadores de Hockey Argentinos
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-[#F97316] mb-6 uppercase tracking-wide" data-id="element-267">
            HOCKEY 360 — Colección Completa
          </h2>
          <p className="text-2xl md:text-3xl text-white font-medium mb-12" data-id="element-268">
            16 Tomos + 6 Bonus + 2 Élite — Todo resuelto. Todas las categorías.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-269">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#F97316] text-white px-6 py-3 rounded-full font-bold text-lg md:text-xl shadow-lg" data-id="element-270">
            +340 páginas
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#F97316] text-white px-6 py-3 rounded-full font-bold text-lg md:text-xl shadow-lg" data-id="element-271">
            +200 ejercicios graficados
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-[#F97316] text-white px-6 py-3 rounded-full font-bold text-lg md:text-xl shadow-lg" data-id="element-272">
            Todas las categorías
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-[#F97316] text-white px-6 py-3 rounded-full font-bold text-lg md:text-xl shadow-lg" data-id="element-273">
            De Escuelita a Mayores
          </motion.div>
        </div>
      </div>
    </section>;
}